import { Box, useStyleConfig } from '@chakra-ui/react';

const MainPanel = (props) => {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig('MainPanel', { variant });
  return (
    <Box
      __css={styles}
      w={{
        base: '100%',
        xl: 'calc(100% - 275px)',
      }}
      mt="18px"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default MainPanel;
